import ViewConstructor from './../components/ViewConstructor.js';
import CaseCard from './../components/CaseCard.js';

class GalleryFavorites extends ViewConstructor {
  componentDidEnter() {
    var user = Cookie.getJSON('gallery-user');
    var $ref = $(`#${ this.state.generatedId }`);

    if (user) {
      // update user details
      if (!user.email) {
        $(window).trigger('show-create-account');
      }
      
      this.getFavoritesFromApi(user);
      this.checkForRemovalOfCases(user);
    } else {
        
      this.checkForRemovalOfCases({ favorites: [] });    
      // no user found. Redirect to login page
      $ref.find('#redirect-login').trigger('click');
    }

    $(window).bind('user-changed', this.userChanged.bind(this));
  }

  componentDidLeave() {
      $(window).unbind('user-changed', this.userChanged.bind(this));
  }

  /**
   * window event listener applied on screen enter and removed on screen leave
   */
  userChanged() {
    var user = Cookie.getJSON('gallery-user');
    
    if (user) {
        this.checkForRemovalOfCases(user);
        this.getFavoritesFromApi(user);
    }
  }

  /**
   * getFavoritesFromApi
   *    
   * This method loops over the favorites stored in the cookie
   * - Then it checks to see if the case exists on page
   * -- IF it does, then it doesn't do anything
   * -- IF the case DOESN'T exists, it will then reach out to the API for that case data && then drop it into a card and post onto the screen.
   * 
   * @param {object} userObject - stored in cookies
   */
  getFavoritesFromApi(userObject) {
    let that = this;

    for (var i = 0; i < userObject.favorites.length; i++) {
        var $ref = $(`#${ this.state.generatedId }`);

        if ($ref.find(`.case-card__inner[case-id="${ userObject.favorites[i] }"]`).length <= 0) {
            this.state.api.getCaseById(userObject.favorites[i], (response) => {
                response.canonical_url += '?favorites=true';

                let favoriteCase = CaseCard(that.state.api.state.url, response, true);

                that.addCardToPage(favoriteCase, response.case_id);
            });
        }
    }
  }

  /** 
   * compare current cases on page to array of cases on user object
  */
  checkForRemovalOfCases(userObject) {
    var $ref = $(`#${ this.state.generatedId }`);

    $ref.find(`.case-card__inner`).each(function(index, $card) {
        let currentId = parseInt($(this).attr('case-id'), 10);

        if (!userObject.favorites.includes(currentId)) {
            $(this).closest('.case-card').remove();
        }
    });
  }


  /**
   * addCardToPage
   *   
   * This first checks to see if current card already exists on page, then appends case to page.
   * 
   * @param {string} htmlCard - string template with Case Card
   * @param {number} caseId - case id of case to be added to page
   */
  addCardToPage(htmlCard, caseId) {
    var $ref = $(`#${ this.state.generatedId }`);
    var $cardContainer = $ref.find('.case-cards');

    if ($cardContainer.find(`.case-card__inner[case-id="${ caseId }"]`).length < 1) {
        $cardContainer.append(htmlCard);
        updateIndexOrder();
    }

    function updateIndexOrder() {
        var user = Cookie.getJSON('gallery-user');
        var $cardContainer = $ref.find('.case-cards');
        
        for (var i = 0; i < user.favorites.length; i++) {
            var currentUser = user.favorites[i];
            $cardContainer.find(`#case-card-${ currentUser }`).closest('.case-card').css('order', i + 1);
        }
    }

    this.state.gallery.addFavoriteLinkListeners();
    this.state.gallery.addLinkEventListeners();
  }

  render() {
    return `
    <div class="account-favorites">
        <h2>Favorites</h2>

        <div class="case-cards">
        
        </div>

        <div class="hide redirects">
            <a href="${ this.state.baseUrl }/my-account/login" id="redirect-login"></a>
        </div>
    </div>
    `;
  }
}

export default GalleryFavorites;


// WEBPACK FOOTER //
// ./src/scripts/site/account-views/favorites.js